import "core-js/modules/es.array.push.js";
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/logo.png';
import _imports_1 from '@/assets/menu.png';
const _withScopeId = n => (_pushScopeId("data-v-419b713d"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_2 = {
  key: 0,
  class: "bar-box"
};
const _hoisted_3 = {
  class: "sub-menu"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "s_t"
}, "蒜小账ERP", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "small_t"
}, "礼品渠道专业全流程SaaS解决方案", -1));
const _hoisted_6 = [_hoisted_4, _hoisted_5];
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "s_t"
}, "蒜小智AI系统", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "small_t"
}, "礼业核心场景的AI智能营销解决方案", -1));
const _hoisted_9 = [_hoisted_7, _hoisted_8];
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "s_t"
}, "蒜小仓WMS", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "small_t"
}, "高度拓展性仓储管理系统", -1));
const _hoisted_12 = [_hoisted_10, _hoisted_11];
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "s_t"
}, "小蒜机器人", -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "small_t"
}, "自动化订单和数据流转方案", -1));
const _hoisted_15 = [_hoisted_13, _hoisted_14];
const _hoisted_16 = {
  key: 1,
  class: "mobile-bar-box"
};
const _hoisted_17 = {
  key: 1,
  class: "enum-popup-box"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "首页", -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "产品服务", -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "客户案例", -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "服务保障", -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "关于我们", -1));
import { computed, ref } from "vue";
import { useRouter } from "vue-router";
import useWindowResize from "@/hooks/useWindowResize";
import { useLockScreen } from "@/hooks/useLockScreen";
export default {
  __name: 'navbar',
  setup(__props) {
    const router = useRouter();
    const routerName = computed(() => router.currentRoute.value.name);
    const windowResizeData = useWindowResize();
    function isActiveMenu(name) {
      if (name == "产品服务") {
        return routerName.value == "蒜小账ERP" || routerName.value == "蒜小智AI" || routerName.value == "蒜小仓" || routerName.value == "小蒜机器人";
      }
      return routerName.value == name;
    }
    const enumVisible = ref(false);
    function showMenu() {
      enumVisible.value = true;
      lockScreen.lock();
    }
    function closeMenu() {
      enumVisible.value = false;
      lockScreen.cleanup();
    }
    const lockScreen = useLockScreen(false);
    return (_ctx, _cache) => {
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_sub_menu = _resolveComponent("el-sub-menu");
      const _component_el_menu = _resolveComponent("el-menu");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(`tabbar-box ${_unref(windowResizeData).isMobile ? 'Mobile_Mode' : ''}`)
      }, [_hoisted_1, !_unref(windowResizeData).isMobile ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", {
        class: _normalizeClass(`item ${isActiveMenu('首页') ? 'active' : ''}`),
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.push('/home'))
      }, " 首页 ", 2), _createElementVNode("div", {
        class: _normalizeClass(`item ${isActiveMenu('产品服务') ? 'active' : ''}`)
      }, [_createTextVNode(" 产品服务 "), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: "item_box",
        onClick: _cache[1] || (_cache[1] = $event => _ctx.$router.push('/product/erp'))
      }, _hoisted_6), _createElementVNode("div", {
        class: "item_box",
        onClick: _cache[2] || (_cache[2] = $event => _ctx.$router.push('/product/ai'))
      }, _hoisted_9), _createElementVNode("div", {
        class: "item_box",
        onClick: _cache[3] || (_cache[3] = $event => _ctx.$router.push('/product/wms'))
      }, _hoisted_12), _createElementVNode("div", {
        class: "item_box",
        onClick: _cache[4] || (_cache[4] = $event => _ctx.$router.push('/product/robot'))
      }, _hoisted_15)])], 2), _createElementVNode("div", {
        class: _normalizeClass(`item ${isActiveMenu('客户案例') ? 'active' : ''}`),
        onClick: _cache[5] || (_cache[5] = $event => _ctx.$router.push('/case'))
      }, " 客户案例 ", 2), _createElementVNode("div", {
        class: _normalizeClass(`item ${isActiveMenu('服务保障') ? 'active' : ''}`),
        onClick: _cache[6] || (_cache[6] = $event => _ctx.$router.push('/service'))
      }, " 服务保障 ", 2), _createElementVNode("div", {
        class: _normalizeClass(`item ${isActiveMenu('关于我们') ? 'active' : ''}`),
        onClick: _cache[7] || (_cache[7] = $event => _ctx.$router.push('/about'))
      }, " 关于我们 ", 2)])) : (_openBlock(), _createElementBlock("div", _hoisted_16, [_unref(windowResizeData).isMobile ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: _imports_1,
        class: "menu-icon",
        alt: "",
        onClick: _cache[8] || (_cache[8] = () => {
          if (enumVisible.value) {
            closeMenu();
          } else {
            showMenu();
          }
        })
      })) : _createCommentVNode("", true), enumVisible.value ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createVNode(_component_el_menu, {
        "default-active": "2",
        class: "el-menu-vertical-demo",
        "active-text-color": "#f76c28",
        router: "",
        defaultActive: _unref(router).currentRoute.value.path,
        defaultOpeneds: ['/product'],
        onSelect: _cache[9] || (_cache[9] = e => {
          closeMenu();
        })
      }, {
        default: _withCtx(() => [_createVNode(_component_el_menu_item, {
          index: "/home"
        }, {
          default: _withCtx(() => [_hoisted_18]),
          _: 1
        }), _createVNode(_component_el_sub_menu, {
          index: "/product"
        }, {
          title: _withCtx(() => [_hoisted_19]),
          default: _withCtx(() => [_createVNode(_component_el_menu_item, {
            index: "/product/erp"
          }, {
            default: _withCtx(() => [_createTextVNode("蒜小账ERP")]),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/product/ai"
          }, {
            default: _withCtx(() => [_createTextVNode("蒜小智AI系统")]),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/product/wms"
          }, {
            default: _withCtx(() => [_createTextVNode("蒜小仓WMS")]),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/product/robot"
          }, {
            default: _withCtx(() => [_createTextVNode("小蒜机器人")]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "/case"
        }, {
          default: _withCtx(() => [_hoisted_20]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "/service"
        }, {
          default: _withCtx(() => [_hoisted_21]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "/about"
        }, {
          default: _withCtx(() => [_hoisted_22]),
          _: 1
        })]),
        _: 1
      }, 8, ["defaultActive"])])) : _createCommentVNode("", true)]))], 2);
    };
  }
};